/*
  Расчёт платежей по условиям, которые сейчас стоят в форме, - 13.10.2026.

  Считает сервер, а не кабинет: взнос, названный здесь, обязан совпасть с тем,
  что назовёт агент и покажет страница должника, а считают их правовым ядром.
  Второй расчёт в кабинете однажды разошёлся бы с ним в копейках.

  Запрос уходит через паузу после последнего нажатия клавиши: на каждую цифру
  отдельный запрос - это десяток ответов, приходящих не по порядку, и на экране
  оставался бы не последний из них.
*/

import { useEffect, useState } from 'react'

import { api } from '../api/client.js'

const PAUSE_MS = 300

export default function useInstalmentPreview(body) {
  const [answered, setAnswered] = useState({ key: null, preview: null })
  const [error, setError] = useState(null)
  // Тело запроса сравнивается строкой: объект формы создаётся заново на каждой
  // перерисовке, и по ссылке эффект срабатывал бы без всякой правки.
  const key = JSON.stringify(body)

  useEffect(() => {
    // Условия ещё не прочитаны - считать нечего.
    if (key === 'null') return undefined
    let current = true
    const timer = setTimeout(() => {
      api
        .instalmentPreview(JSON.parse(key))
        .then((answer) => {
          if (!current) return
          setAnswered({ key, preview: answer })
          setError(null)
        })
        .catch((failure) => {
          if (current) setError(failure)
        })
    }, PAUSE_MS)
    return () => {
      current = false
      clearTimeout(timer)
    }
  }, [key])

  /*
    `pending` - на экране ответ на прежние значения полей (13.10.2026, осмотр):
    пока шёл пересчёт, ответ на пустой срок говорил «рассрочка ему не нужна» при
    уже введённых двенадцати месяцах. Прежняя таблица остаётся - мигать ей на
    каждую цифру хуже, - а выводы по ней экран не делает.
  */
  return { preview: answered.preview, pending: answered.key !== key, error }
}
